<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="480px">
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span>Reject JO</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      label="Reference Number*"
                      v-model="form.referenceNumber"
                      :rules="rules.required"
                      disabled
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" class="mt-0 pt-0">
                    <v-select
                      label="Reason"
                      :items="reasons"
                      @change="selectReason($event)"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" v-if="inputOthers" class="mt-0 pt-0">
                    <v-textarea
                      v-model="form.reason"
                      label="Other Reason"
                      rows="2"
                      auto-grow
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingBtn" @click.native="cancel">
                Close
              </v-btn>
              <v-btn
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onSubmit()"
                class="px-10"
              >
                Submit
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <Snackbar></Snackbar>
    </v-col>
  </v-row>
</template>

<script>
// import moment from "moment";
import Snackbar from "../Snackbar.vue";
import ShareableMethods from "@/mixins/ShareableMethods";

export default {
  mixins: [ShareableMethods],
  name: "CancelAquisition",
  components: {
    Snackbar,
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,

      selectedData: null,

      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },

      form: {
        referenceNumber: "",
        reason: "",
      },

      reasons: [
        "No nearby NAP",
        "No or Incomplete application form provided",
        "Commercial Area",
        "Applicant is a Converge postpaid subscriber",
        "Applicant resides in restricted area",
        "Others",
      ],

      inputOthers: false,
    };
  },

  methods: {
    open(data) {
      this.dialog = true;

      this.selectedData = data;
      //
      setTimeout(() => {
        const currentData = data;
        const form = this.form;
        Object.keys(form)
          .filter((key) => key in currentData)
          .forEach((key) => {
            form[key] = currentData[key];
          });
      }, 500);
      // this.getDispatchConfig();
      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    // async doReject() {
    //   // this.table.loading = true;

    // },

    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.loadingBtn = true;

      await this.$api
        .delete("/dashboard/jo-approver", {
          data: { _id: this.selectedData._id, reason: this.form.reason },
        })

        .then((response) => {
          const res = response.data;
          this.loadingBtn = false;
          if (!res.status) {
            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);
            return;
          }
          this.$store.dispatch("addSnackbarMessage", res.message);
          this.$store.dispatch("addSnackbar", true);
          this.agree();
        })
        .catch((e) => {
          this.loadingBtn = true;
          console.log(e);
        });

      // await this.$api
      //   .post("/acquisition/cancel-signup", this.form)
      //   .then((response) => {
      //     const res = response.data;

      //     if (!res.status) {
      //       this.loadingBtn = false;
      //       this.$store.dispatch("addSnackbarMessage", res.message);
      //       this.$store.dispatch("addSnackbar", true);
      //       return;
      //     }

      //     this.loadingBtn = false;
      //     this.$refs.form.reset();
      //     this.$store.dispatch("addSnackbarMessage", res.message);
      //     this.$store.dispatch("addSnackbar", true);
      //     this.agree();
      //   })
      //   .catch((e) => {
      //     console.log(e);
      //     this.loadingBtn = false;
      //   });
    },

    selectReason(e) {
      if (e === "Others") {
        this.inputOthers = true;
        this.form.reason = "";
        return;
      }

      this.inputOthers = false;
      this.form.reason = e;
      return;
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },

    cancel() {
      this.resolve(false);
      this.inputOthers = false;
      this.$refs.form.reset();
      this.dialog = false;
    },
  },

  created() {},
};
</script>

<style scoped>
.images > img {
  cursor: pointer;
}
</style>
